(function () {
  'use strict';

  var ATTR = 'data-product-list-swiper';
  var instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root) || typeof Swiper === 'undefined') return;

    var slideCount = root.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    var shell = root.closest('.product-list-shell');
    var navRoot = shell ? shell.querySelector('.swiper-buttons') : root.querySelector('.swiper-buttons');
    var prevEl = navRoot ? navRoot.querySelector('.swiper-button-prev') : null;
    var nextEl = navRoot ? navRoot.querySelector('.swiper-button-next') : null;

    var swiper = new Swiper(root, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      threshold: 8,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
    });

    instances.set(root, swiper);
  }

  function destroyIn(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(function (root) {
      var swiper = instances.get(root);
      if (!swiper) return;
      swiper.destroy(true, true);
      instances.delete(root);
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event && event.target) destroyIn(event.target);
  });
})();
